import * as events from './events';
import * as mapping from './mapping';

export const destinationMetaExamples = {
  events,
  mapping
};
